import React from "react";
import { useDispatch } from "react-redux";
import withModal from "../withModal";
import { DeleteFieldLabel } from "../../../actions/fieldLabelsActions";
import { hideModal } from "../../../actions/actionCreators";
import MaterialModal from "../MaterialModal";

// Types and Interfaces
type IModalProps = {
    id: number;
};

type IProps = {
    isOpen: boolean;
    modalProps: IModalProps;
};

const FieldLabelDeleteModal: React.FC<IProps> = ({ modalProps, isOpen }: IProps) => {
    const dispatch = useDispatch();

    const hide = () => dispatch(hideModal("FIELD_LABEL_DELETE"));
    const deleteFieldLabel = () => {
        dispatch(DeleteFieldLabel(modalProps.id));
        hide();
    };

    return (
        <MaterialModal
            title="Delete Field Label"
            isOpen={isOpen}
            onClose={hide}
            onPrimaryButtonRequest={deleteFieldLabel}
            primaryButtonText="Delete"
            id="delete"
            maxWidth="lg"
        >
            <span>
                Are you sure you want to <strong className="text-danger">delete</strong> this field label?
                <br />
                <strong className="text-danger">
                    This action is permanent; the field label cannot be recovered after deletion.
                </strong>
            </span>
        </MaterialModal>
    );
};

export default withModal(FieldLabelDeleteModal, "FIELD_LABEL_DELETE");
